import { PaginationType } from '../../types/pagination';
import { DefaultRequest, IdValue } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export interface FetchTagStaffRequest extends DefaultRequest {}

export const fetchTagStaff = async (): Promise<{ tag: IdValue[] } & PaginationType> => {
  const response = await baseFetch(`${managerApiUrl}/tag/staff`);
  return response;
};

export const postTagStaff = async (tag: string): Promise<void> => {
  await baseFetch(`${managerApiUrl}/tag/staff`, {
    method: 'POST',
    body: JSON.stringify({ name: tag }),
  });
};

export const deleteTagStaff = async (id: string): Promise<void> => {
  await baseFetch(`${managerApiUrl}/tag/staff/${id}`, {
    method: 'DELETE',
  });
};
